var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 2.6001C7.2567 2.6001 2.6001 7.2567 2.6001 13.0001C2.6001 18.214 6.44116 22.5196 11.4453 23.2718V15.7561H8.87216V13.0226H11.4453V11.2035C11.4453 8.19183 12.9126 6.87016 15.4155 6.87016C16.6141 6.87016 17.2485 6.95943 17.5484 6.9993V9.38523H15.841C14.7785 9.38523 14.4076 10.3932 14.4076 11.5285V13.0226H17.5215L17.0994 15.7561H14.4076V23.2935C19.4836 22.6054 23.4001 18.2651 23.4001 13.0001C23.4001 7.2567 18.7435 2.6001 13.0001 2.6001Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9c7425d8d27ef423af76808d6f1e8e3e.svg";
export { ForwardRef as ReactComponent };